import { toast } from "sonner";
import { apiAuth } from ".";

/** Ferramentas de PDF (LOT-60) */

export type PdfCompressLevel = "recommended" | "extreme" | "low";

export interface JpgToPdfOptions {
  orientation: "auto" | "portrait" | "landscape";
  page_size: "a4" | "image";
  margin: "none" | "small" | "big";
}

export interface PdfToolResult {
  blob: Blob;
  originalSize?: number;
  compressedSize?: number;
}

/**
 * Envia os arquivos e recebe o PDF. Em erro a API responde JSON, que chega como Blob por causa do
 * responseType; aqui a mensagem é lida do corpo e mostrada em toast (o interceptor não alcança o Blob).
 */
const postPdfTool = async (path: string, form: FormData): Promise<PdfToolResult | null> => {
  const response: any = await apiAuth.post(path, form, {
    responseType: "blob",
    validateStatus: () => true,
  });

  if (response.status === 200 && response.data instanceof Blob) {
    const header = (name: string) => {
      const value = Number(response.headers?.[name]);
      return Number.isFinite(value) && value > 0 ? value : undefined;
    };

    return {
      blob: response.data,
      originalSize: header("x-original-size"),
      compressedSize: header("x-compressed-size"),
    };
  }

  if (response.status === 401) {
    toast.error("Sessão expirada, por favor faça login novamente");
    window.location.href = "/login";
    return null;
  }

  let message = "Não foi possível processar o arquivo.";

  try {
    const body = JSON.parse(await (response.data as Blob).text());
    const detail = body?.response;
    message = Array.isArray(detail) ? detail.join(" ") : body?.message || message;
  } catch {
    // mantém a mensagem padrão
  }

  toast.error(message);

  return null;
};

export const compressPdf = (file: File, level: PdfCompressLevel) => {
  const form = new FormData();
  form.append("file", file);
  form.append("level", level);

  return postPdfTool("pdf-tools/compress", form);
};

export const jpgToPdf = (images: File[], options: JpgToPdfOptions) => {
  const form = new FormData();
  images.forEach((image) => form.append("images[]", image));
  form.append("orientation", options.orientation);
  form.append("page_size", options.page_size);
  form.append("margin", options.margin);

  return postPdfTool("pdf-tools/jpg-to-pdf", form);
};
